export const genders = Object.freeze([
  { id: 'M', name: 'Masculino' },
  { id: 'F', name: 'Femenino' },
  { id: 'O', name: 'Otro' },
]);
